import { createSlice } from '@reduxjs/toolkit';
import { isMobile } from 'react-device-detect';
import { LocalStorageWrap } from '../../utils';
const user = LocalStorageWrap.getItem(LocalStorageWrap.USER_DETAILS);

const app = createSlice({
  name: 'app',
  initialState: {
    user: {
      username: user?.username || '',
      token: user?.token || '',
      role: user?.role || 0,
      isLoggedin: user ? true : false,
    },
    dashboardList: [],
    dashboardCount: 0,
    serviceList: [],
    serviceCount: 0,
    projectList: [],
    hookList: [],
    projectName: [],
    userList: [],
    userDetail: [],
    ServiceDetails: [],
    serviceId: '',
    projectId: '',
    logsarray: [],
    logsarrayonsearch: [],
    alerts: [],
    health: [],
    isMobile,
    sprogress: false,
  },
  reducers: {
    setDashboardList(state, action) {
      state.dashboardList = action.payload.list;
      state.dashboardCount = action.payload.count;
    },
    setServiceList(state, action) {
      state.serviceList = action.payload.list;
      state.serviceCount = action.payload.count;
    },
    updateServiceList(state, action) {
      const serviceList = [...state.serviceList];
      const { data, operation } = action.payload;
      if (operation === 'create') {
        serviceList.unshift(data);
        state.serviceCount += 1;
      } else if (operation === 'edit') {
        const index = serviceList.findIndex((service) => service.id === data.id);
        if (index !== -1) serviceList[index] = { ...serviceList[index], ...data };
      } else if (action.payload.operation === 'delete') {
        const index = serviceList.findIndex((service) => service.id === data.id);
        if (index !== -1) serviceList.splice(index, 1);
        state.serviceCount -= 1;
      }
      state.serviceList = serviceList;
    },
    setProjectList(state, action) {
      state.projectList = action.payload.list;
      state.projectCount = action.payload.count;
    },
    setHookList(state, action) {
      state.hookList = action.payload.list;
      state.hookCount = action.payload.count;
    },
    setAlerts(state, action) {
      state.alerts = action.payload;
    },
    setSprogress(state, action) {
      state.sprogress = action.payload;
    },
    setProjectName(state, action) {
      state.projectName = action.payload;
    },
    setUserList(state, action) {
      state.userList = action.payload.list;
      state.userCount = action.payload.count;
    },
    setUserDetail(state, action) {
      state.userDetail = action.payload.list;
    },
    setServiceDetails(state, action) {
      state.ServiceDetails = action.payload.list;
    },
    setService(state, action) {
      state.serviceId = action.payload;
    },
    setProject(state, action) {
      state.projectId = action.payload;
    },
    setLogsarray(state, action) {
      state.logsarray = action.payload;
    },
    setLogsarrayonsearch(state, action) {
      state.logsarrayonsearch = action.payload;
    },
    setHealth(state, action) {
      state.health = action.payload;
    },
    updateUserList(state, action) {
      const userList = [...state.userList];
      const { data, operation } = action.payload;
      if (operation === 'create') {
        userList.unshift(data);
        state.userCount += 1;
      } else if (action.payload.operation === 'edit') {
        const index = userList.findIndex((user) => user.id === data.id);
        if (index !== -1) userList[index] = { ...userList[index], ...data };
      } else if (action.payload.operation === 'delete') {
        const index = userList.findIndex((user) => user.id === data.id);
        if (index !== -1) userList.splice(index, 1);
        state.userCount -= 1;
      }
      state.userList = userList;
    },
    updateProjectList(state, action) {
      const projectList = [...state.projectList];
      const { data, operation } = action.payload;
      if (operation === 'create') {
        projectList.unshift(data);
        state.projectCount += 1;
      } else if (action.payload.operation === 'edit') {
        const index = projectList.findIndex((project) => project.id === data.id);
        if (index !== -1) projectList[index] = { ...projectList[index], ...data };
      } else if (action.payload.operation === 'delete') {
        const index = projectList.findIndex((project) => project.id === data.id);
        if (index !== -1) projectList.splice(index, 1);
        state.projectCount -= 1;
      }
      state.projectList = projectList;
    },
    updateHookList(state, action) {
      const hookList = [...state.hookList];
      const { data, operation } = action.payload;
      if (operation === 'create') {
        hookList.unshift(data);
        state.hookCount += 1;
      } else if (action.payload.operation === 'edit') {
        const index = hookList.findIndex((hook) => hook.id === data.id);
        if (index !== -1) hookList[index] = { ...hookList[index], ...data };
      } else if (action.payload.operation === 'delete') {
        const index = hookList.findIndex((hook) => hook.id === data.id);
        if (index !== -1) hookList.splice(index, 1);
        state.hookCount -= 1;
      }
      state.hookList = hookList;
    },
    updateLogsarray(state, action) {
      const logsarray = [...state.logsarray];
      const { data, operation } = action.payload;
      if (operation === 'create') {
        for (let i = 0; i <= data.length - 1; i++) {
          logsarray.unshift(data[i.toString()]);
        }
      }
      state.logsarray = logsarray;
    },
    updateAlerts(state, action) {
      const alerts = [...state.alerts];
      const { data, operation } = action.payload;
      if (operation === 'create') {
        alerts.unshift(data);
      }
      state.alerts = alerts;
    },
    updateHealth(state, action) {
      const health = [...state.health];
      const { data, operation } = action.payload;
      if (operation === 'create') {
        health.unshift(data);
      }
      state.health = health;
    },
    setLogin(state, action) {
      if (action.payload.isLoggedin) {
        state.user.username = action.payload.username;
        state.user.token = action.payload.token;
        state.user.role = action.payload.role;
        state.user.isLoggedin = action.payload.isLoggedin;
      } else {
        state.user.username = '';
        state.user.token = '';
        state.user.role = 0;
        state.user.isLoggedin = false;
      }
    },
  },
});

export default app.reducer;

export const {
  setServiceList,
  updateServiceList,
  setProjectList,
  setLogin,
  setHookList,
  setProjectName,
  setUserList,
  setUserDetail,
  updateUserList,
  setAlerts,
  setServiceDetails,
  updateProjectList,
  updateHookList,
  setLogsarray,
  setLogsarrayonsearch,
  setService,
  setProject,
  updateLogsarray,
  updateAlerts,
  setHealth,
  updateHealth,
  setSprogress,
  setDashboardList,
} = app.actions;
